<div class="custom-select" [ngClass]="{
    'border': $config().style?.border,
    'opacity-25 disabled': $disabled(),
    'host-full-width': $config().style?.hostFullWidth,
    }">

    <button type="button" class="items-center rounded-sm px-4 py-2 pr-0 flex flex-row gap-2 text-gray-700"
        [floatUiLoose]="dropdownContent"
        [showOnStart]="false"
        [looseTrigger]="'click'"
        [loosePlacement]="$dropdownPosition()"
        [preventOverflow]="true"
        [hideOnClickOutside]="true"
        (onHidden)="hide()"
        [ngClass]="{
            'main-btn bg-white': !$config().style?.greyBackground,
            'bg-gray-400 inline-flex justify-between w-full lg:w-[30.7rem]': $config().style?.greyBackground,
            'w-full': $config().style?.hostFullWidth,
        }"
        [attr.data-has-value-selected]="$config().style?.showOutlineWhenHasValue && !!$selectedOption()?.value">
        <span class="selected-option inline-flex items-center gap-1.6">
            @if ($selectedOption()?.icon) {
                <meta-icon [icon]="$selectedOption()?.icon!" 
                    [additionalClasses]="'p-1 ' + ($config().style?.biggerIcons ? 'text-[2.4rem]': '')"/>
            }
            @if ($selectedOption()?.color) {
                <span class="shrink-0 size-4 p-0.2" [style.backgroundColor]="$selectedOption()?.color"></span>
            }
            <span [ngClass]="{
                'font-bold': $config().style?.boldLabel,
                'text-sm': $config().style?.smallerLabel
            }" [innerHTML]="$selectedOption()?.label ?? '' | translate | sanitize:'bypassSecurityTrustHtml'"></span>
        </span>
        @if ($selectedOption()?.value && $config().hasDeleteBtn) {
            <meta-icon icon="trash" (click)="$event.stopPropagation(); selectOption($defaultOption())"
                [additionalClasses]="'text-text-red-600 inline-flex items-center ' + ($config().style?.smallerLabel ? 'text-[0.8rem]' : '') " />
        } @else {
            <meta-icon icon="angle-bottom" [additionalClasses]="'inline-flex items-center ' + ($config().style?.smallerLabel ? 'text-[0.8rem]' : 'text-[1rem]')" />
        }
    </button>
    <float-ui-content #dropdownContent>
        <div class="p-0.4 max-h-[50vh] overflow-y-auto min-w-full overflow-x-hidden">
            @if (!options()) {
                <meta-loading [standAlone]="true" type="points" />
            } @else {
                <ul>
                    @for (item of $options(); track $index) {
                        <li>
                            @if ($config().multipleSelection) {
                                <label [attr.for]="item.value" class="cursor-pointer flex-1 w-full inline-flex items-center rounded-1.6 hover:bg-test-light-gray focus-visible:outline-none focus-visible:bg-test-light-gray"
                                    (click)="item.value || item.disabled ? undefined : selectOption(item)" [ngClass]="{
                                        'opacity-25 disabled': item.disabled
                                    }">
                                    <span class="flex-1 inline-flex items-center gap-0.8">
                                        @if (item.icon) {
                                            <meta-icon [icon]="item.icon!" 
                                                [additionalClasses]="'p-1 ' + ($config().style?.biggerIcons ? 'text-[2.4rem]': '')"/>
                                        }
                                        @if (item.color) {
                                            <span class="shrink-0  size-4 p-0.2" [style.backgroundColor]="item.color"></span>
                                        }
                                        <span class="inline-flex text-base font-medium" [innerHTML]="item.label | translate | sanitize:'bypassSecurityTrustHtml'"></span>
                                    </span>
                                    @if (item.value) {
                                        <input [attr.id]="item.value" type="checkbox" name="checkbox" type="checkbox" autocomplete="off" 
                                            (change)="selectOption(item)" [checked]="item.selected" [disabled]="item.disabled"/>
                                    }
                                </label>
                            } @else {
                                <button type="button" (click)="selectOption(item)"
                                    [disabled]="item.disabled" [ngClass]="{
                                        'bg-test-light-gray': item.selected,
                                        'opacity-25 disabled': item.disabled
                                    }">
                                    @if (item.icon) {
                                        <meta-icon [icon]="item.icon!" 
                                            [additionalClasses]="'p-1 ' + ($config().style?.biggerIcons ? 'text-[2.4rem]': '')"/>
                                    }
                                    @if (item.color) {
                                        <span class="shrink-0 size-4 p-0.2" [style.backgroundColor]="item.color"></span>
                                    }
                                    <span class="text-base font-medium" [innerHTML]="item.label | translate | sanitize:'bypassSecurityTrustHtml'"></span>
                                </button>
                            }
                        </li>
                    }
                </ul>
            }
        </div>
    </float-ui-content>
</div>
